import { PlatformId } from "views/page-content/platforms/types";
import { DestinationDescriptor } from "views/page-content/platforms/platform/simulcast/types";
import { useTranslation } from "react-i18next";
import { PlatformSubsettingsBase } from "../../PlatformSubsettingsBase";
import styles from "./index.module.scss";
import { Spinner } from "components/spinners/Spinner";

export const DestinationSelection = ({
    timelineDestinations,
    pageDestinations,
    isPaginated,
    loadMore,
    fbLoadingMore = false,
    setHasAddedPlatformSpecificSettings,
    setCurrentFacebookEdge,
    setSpecificDestination
}) => {
    const { t } = useTranslation();
    return (
        <div>
            <div>
                <PlatformSubsettingsBase
                    destinationNameKey="name"
                    destinations={timelineDestinations}
                    imgSrcKey={"picture.data.url"}
                    onDestinationClick={(d: DestinationDescriptor) => {
                        setCurrentFacebookEdge("me");
                        setSpecificDestination({
                            ...d,
                            platformSpecificSettings: {
                                edge: "me"
                            }
                        });
                        setHasAddedPlatformSpecificSettings(true);
                    }}
                    platformId={PlatformId.Facebook}
                    headingText={t("facebook-destination:timeline")}
                />
            </div>
            <div>
                <PlatformSubsettingsBase
                    destinationNameKey="name"
                    destinations={pageDestinations}
                    imgSrcKey={"picture.data.url"}
                    onDestinationClick={(d: DestinationDescriptor) => {
                        setCurrentFacebookEdge("accounts");
                        setSpecificDestination({
                            ...d,
                            platformSpecificSettings: {
                                edge: "accounts"
                            }
                        });
                        setHasAddedPlatformSpecificSettings(true);
                    }}
                    platformId={PlatformId.Facebook}
                    headingText={t("facebook-destination:page")}
                />
                {isPaginated && loadMore && (
                    <>
                        {fbLoadingMore ? (
                            <div className={styles["load-more-wrapper"]}>
                                <Spinner />
                            </div>
                        ) : (
                            <div className={styles["load-more-wrapper"]}>
                                <button
                                    onClick={loadMore}
                                    className={`btn btn-outline-secondary`}
                                >
                                    {t("facebook-destination:load-more")}
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
